import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsulinCenter, InsulinType } from 'src/app/_models/PSP/psp-insulin.model';
import { GenericResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root'
})
export class PspInsulinService {

  getInsulinTypesUrl = 'api/PspInsulin/GetInsulinTypes';
  getInsulinCentersUrl = 'api/PspInsulin/GetInsulinCenters';

  constructor(private http: HttpClient) { }


  getInsulinTypes(): Observable<GenericResponse<InsulinType[]>> {
    return this.http.get<GenericResponse<InsulinType[]>>(this.getInsulinTypesUrl);
  }

  getInsulinCenters(): Observable<GenericResponse<InsulinCenter[]>> {
    return this.http.get<GenericResponse<InsulinCenter[]>>(this.getInsulinCentersUrl);
  }

  getInsulinCentersByArea(areaId: number): Observable<GenericResponse<InsulinCenter[]>> {
    const params = new HttpParams().set('areaId', areaId);
    return this.http.get<GenericResponse<InsulinCenter[]>>(this.getInsulinCentersUrl, {params});
  }
}
